import {ReactElement, useState} from "react";
import {Body, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {Button} from "@zendeskgarden/react-buttons";
import UserFormInput from "../users/components/user-form/UserFormInput";
import * as formCss from "../users/components/user-form/styles/userFormStyles.module.scss";
import {useAddGprEntityGroupMutation, useUpdateGprEntityGroupMutation} from "../../../__generated__/generated_types";
import {toast} from "react-toastify";

interface GPREGroupFormModalProps {
    closed: (saved: boolean) => void;
    budgetYear: number;
    existingGroup?: {
        id: string;
        name: string;
    };
}

export function GPREGroupFormModal(props: GPREGroupFormModalProps): ReactElement {
    const [createGroup, {loading: createLoading}] = useAddGprEntityGroupMutation({});
    const [updateGroup, {loading: updateLoading}] = useUpdateGprEntityGroupMutation({});
    const [name, setName] = useState<string>(props.existingGroup?.name ?? "");
    const [nameTouched, setNameTouched] = useState<boolean>(false);

    function doSave(): void {
        let promise: Promise<unknown>;
        if(props.existingGroup) {
            promise = updateGroup({
                variables: {
                    budgetYear: props.budgetYear,
                    groupId: props.existingGroup.id,
                    groupName: name
                }
            });
        } else {
            promise = createGroup({
                variables: {
                    budgetYear: props.budgetYear,
                    groupName: name
                }
            });
        }

        promise.then(() => {
            toast.success("Group Saved!");
            props.closed(true);
        }).catch(() => {/* Do Nothing */});
    }

    return <Modal>
        <Header>
            {props.existingGroup ? "Edit Group" : "Create Group"}
        </Header>
        <Body>
            <form className={formCss.userForm}>
                <UserFormInput
                    label="Name"
                    placeholder="Group Name"
                    required
                    value={name}
                    error={nameTouched && name === "" ? "Name cannot be empty." : undefined}
                    onChange={(evt) => {
                        setName(evt.target.value);
                        setNameTouched(true);
                    }}
                    onBlur={() => {/* Do Nothing */}}
                />
            </form>
        </Body>
        <Footer>
            <FooterItem>
                <Button onClick={() => props.closed(false)}>Cancel</Button>
            </FooterItem>
            <FooterItem>
                <Button
                    isPrimary
                    disabled={createLoading || updateLoading || !(name && name !== "")}
                    onClick={() => doSave()}
                >Save</Button>
            </FooterItem>
        </Footer>
    </Modal>;
}
